import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { useState, type FC } from 'react';
import { useCheckRoleAccess } from 'infrastructure/hooks';
import BaseButton from 'components/atoms/baseButton';
import { DownOutlined, RightOutlined } from '@ant-design/icons';

import s from './styles.module.scss';
import PatientAppointmentDetails from '../appointment-details';
import PatientSelfGoals from '../patient-self-goals';
import PatientHealthQuestionnaire from '../patient-health-questionnaire';

interface ServicesProps {
  patientGuid: string;
}

const Services: FC<ServicesProps> = ({ patientGuid }) => {
  const { t } = useTranslation();
  const { isReadOnlyRole } = useCheckRoleAccess();
  const [isExpanded, setIsExpanded] = useState(true);

  const items = [
    {
      key: 'appointment',
      label: t('labels.patientAppointment'),
      children: (
        <PatientAppointmentDetails
          patientGuid={patientGuid}
          disableActions={isReadOnlyRole}
        />
      ),
    },
    {
      key: 'goals',
      label: t('labels.patientGoals'),
      children: (
        <PatientSelfGoals
          patientGuid={patientGuid}
          withoutCondition
          disableActions={isReadOnlyRole}
        />
      ),
    },
    {
      key: 'questionnaire',
      label: t('labels.questionnaire'),
      children: (
        <PatientHealthQuestionnaire
          patientGuid={patientGuid}
          disableActions={isReadOnlyRole}
        />
      ),
    },
  ];

  return (
    <div className={s.wrapper} id="services">
      <div className={s.header}>
        <BaseButton
          type="secondary"
          className={s['toggle-button']}
          icon={isExpanded ? <DownOutlined /> : <RightOutlined />}
          onClick={() => setIsExpanded(!isExpanded)}
        />
        <h4 className={s.title}>{t('labels.chronicCareManagementCcm')}</h4>
      </div>
      {isExpanded && (
        <Tabs defaultActiveKey="appointment" items={items} className={s.tabs} />
      )}
    </div>
  );
};

export default Services;
